import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import {MatDivider} from '@angular/material/divider';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {StatusChipComponent} from '@aviary/components/status-chip/status-chip.component';
import {FALLBACK_CHECKOUT} from '@store/checkouts/checkouts.fallback';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';
import {CHECKOUT_CLAIM_TYPE_CHIP_COLORS, CheckoutClaimDialogData, DISPLAYABLE_CHECKOUT_CLAIM_TYPE} from '@store/checkouts/checkouts.types';
import {CheckoutDetailComponent} from '@app/my-account/checked-out/detail/checkout-detail.component';
import {MatChipSet} from '@angular/material/chips';
import {MEDIUM_DIALOG_CONFIG} from '@aviary/dialogs/base-dialog/base-dialog.types';

@Component({
  selector: 'px-view-claim-dialog',
  template: `
    <mx-confirmation-dialog [definition]="dialogDefinition" [showCancelButton]="false">
      <mat-chip-set>
        <mx-status-chip [status]="selectors.typeFor(claim) | select" [colors]="CHECKOUT_CLAIM_TYPE_CHIP_COLORS"
                        [displayableStatusNames]="DISPLAYABLE_CHECKOUT_CLAIM_TYPE"/>
      </mat-chip-set>
      <px-checkout-detail [checkout]="selectors.checkoutFor(claim) | select: FALLBACK_CHECKOUT" [showDueDate]="false"/>
      <mat-divider/>
      <div class="text-title-large">Claim Details</div>
      <div>{{ (selectors.patronCommentFor(claim) | select) || 'No comment provided.' }}</div>
      <div class="flex justify-end">
        <div>Submitted: {{ selectors.createdFor(claim) | select | format: 'DATE_ONLY' }}</div>
      </div>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmationDialogComponent, CheckoutDetailComponent, FormatPipe, SelectPipe, StatusChipComponent, MatDivider, MatChipSet]
})
export class ViewClaimDialog implements ConfirmationDialog<CheckoutClaimDialogData> {
  public static readonly dialogConfigOverrides: MatDialogConfig = MEDIUM_DIALOG_CONFIG;
  public readonly selectors = CheckoutsSelectors.StatelessClaims;
  public readonly dialogData: CheckoutClaimDialogData = inject(MAT_DIALOG_DATA);
  public readonly claim = this.dialogData.checkoutClaim;
  public readonly DISPLAYABLE_CHECKOUT_CLAIM_TYPE = DISPLAYABLE_CHECKOUT_CLAIM_TYPE;
  public readonly CHECKOUT_CLAIM_TYPE_CHIP_COLORS = CHECKOUT_CLAIM_TYPE_CHIP_COLORS;
  public readonly FALLBACK_CHECKOUT = FALLBACK_CHECKOUT;

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'View Claim',
    confirmButtonLabel: 'Close'
  };
}
